import { ResponseCodes } from '@store/services/types';
import { AxiosError } from 'axios';

export const LINK_ALREADY_USED_COPY = {
  title: 'Link already used',
  text: 'This link has already been used. Please, contact your administrator if you need a new one.',
};

/**
 * Read the machine-readable error code the back end sets on invite/reset link failures.
 * Works with both raw axios errors (error.response.data.code) and RTK query errors (error.data.code).
 */
export const getResponseCode = (error: unknown): ResponseCodes | undefined => {
  const axiosCode = (error as AxiosError<{ code?: ResponseCodes }>)?.response
    ?.data?.code;
  const rtkCode = (error as { data?: { code?: ResponseCodes } })?.data?.code;

  return axiosCode ?? rtkCode;
};

export const isLinkAlreadyUsedError = (error: unknown): boolean =>
  getResponseCode(error) === ResponseCodes.LINK_ALREADY_USED;
